/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Inbound_Not_EditableInputs */

const en_error_inbound_not_editable = /** @type {(inputs: Error_Inbound_Not_EditableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This inbound can no longer be changed: it was sent, or Tomorrow or the brand moved it on. Reload the page to see where it is.`)
};

/**
* | output |
* | --- |
* | "This inbound can no longer be changed: it was sent, or Tomorrow or the brand moved it on. Reload the page to see where it is." |
*
* @param {Error_Inbound_Not_EditableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_inbound_not_editable = /** @type {((inputs?: Error_Inbound_Not_EditableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Inbound_Not_EditableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_inbound_not_editable(inputs)
});